import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-registration-success',
  template: `
    <div class="registration-success-container">
      <div class="success-card">
        <div class="success-icon">
          <i class="material-icons">check_circle</i>
        </div>
        <h2>Registration Successful!</h2>
        <p>Your account has been successfully created and registered.</p>
        <div class="actions">
          <button mat-raised-button color="primary" (click)="goToLogin()">
            Continue to Login
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .registration-success-container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      background-color: #f5f5f5;
    }
    
    .success-card {
      background: white;
      padding: 2rem;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      text-align: center;
      max-width: 400px;
      width: 100%;
    }
    
    .success-icon i {
      font-size: 4rem;
      color: #4caf50;
    }
    
    h2 {
      margin: 1rem 0;
      color: #333;
    }
    
    p {
      margin: 0.5rem 0;
      color: #666;
    }
    
    .actions {
      margin-top: 2rem;
    }
  `]
})
export class RegistrationSuccessComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  
  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}